import { TagProps } from 'antd';
import { capitalize } from 'lodash-es';
import { memo } from 'react';
import toLowerCase, { toUpperCase } from 'utils/toLowerCase';
import { BlueTag, GreenTag, RedTag, BlackTag } from './styled/tags';
import { platformLabelMap } from 'services/config/platform';

export interface PlatformTagProps extends TagProps {
  platform: General.CaselessPlatformTunnel;
}

const PlatformTag = (props: PlatformTagProps) => {
  const { platform, ...tagsProps } = props;
  const upperPlatform = toUpperCase(platform);
  const label = platformLabelMap[toLowerCase(platform)];

  switch (upperPlatform) {
    case 'SHOPEE': {
      return <RedTag {...tagsProps}>{label}</RedTag>;
    }
    case 'LAZADA': {
      return <BlueTag {...tagsProps}>{label}</BlueTag>;
    }
    case 'TIKTOK':
    case 'TIKTOK_US': {
      return <BlackTag {...tagsProps}>{label}</BlackTag>;
    }
    default: {
      return (
        <GreenTag {...tagsProps}>
          {label || capitalize(platform === 'WA_BIZ' ? 'WhatsApp' : platform)}
        </GreenTag>
      );
    }
  }
};
export default memo(PlatformTag);
